import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About Digital Dream Safaris</h1>
          <p className="about-hero-subtitle">
            Your trusted local partner for unforgettable Tanzanian adventures
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="about-section">
          <h2>Who We Are</h2>
          <p>
            Digital Dream Safaris is a Tanzanian local-owned tour operator specializing in 
            Kilimanjaro Climbs, Wildlife Safaris, and Beach Vacations. We are passionate about 
            showcasing the natural beauty and cultural richness of Tanzania to travelers from 
            around the world.
          </p>
          <p>
            Based in Arusha, Tanzania, we have deep local knowledge and connections that allow 
            us to provide authentic, memorable experiences. Our team consists of experienced 
            guides, knowledgeable staff, and dedicated support personnel who are committed to 
            making your Tanzanian adventure truly special.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide exceptional, authentic Tanzanian travel experiences while 
            supporting local communities and promoting sustainable tourism practices. We believe 
            in creating meaningful connections between travelers and the incredible landscapes, 
            wildlife, and cultures of Tanzania.
          </p>
        </div>

        <div className="about-section">
          <h2>Why Choose Us</h2>
          <div className="about-features">
            <div className="about-feature">
              <h3>Local Expertise</h3>
              <p>
                As a Tanzanian-owned company, we have insider knowledge of the best destinations, 
                hidden gems, and optimal travel times.
              </p>
            </div>
            <div className="about-feature">
              <h3>Custom Made Safaris</h3>
              <p>
                We create personalized itineraries tailored to your interests, budget, and travel 
                style, ensuring a unique experience.
              </p>
            </div>
            <div className="about-feature">
              <h3>Best Prices Guaranteed</h3>
              <p>
                We offer competitive pricing without compromising on quality, providing excellent 
                value for your investment.
              </p>
            </div>
            <div className="about-feature">
              <h3>24/7 Quick Response</h3>
              <p>
                Our dedicated team is always available to assist you, answer questions, and provide 
                support throughout your journey.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>Our Services</h2>
          <ul className="about-services">
            <li>Kilimanjaro Climbing Expeditions</li>
            <li>Wildlife Safari Tours</li>
            <li>Beach Vacations</li>
            <li>Cultural Tours</li>
            <li>Custom Itineraries</li>
            <li>Group and Private Tours</li>
          </ul>
        </div>

        <div className="about-cta">
          <h2>Ready to Start Your Adventure?</h2>
          <p>Contact us today to plan your perfect Tanzanian experience</p>
          <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;

